import { Flex, Button } from '@applyboard/crystal-ui';
import { PlusOutlineIcon } from '@applyboard/ui-icons';

interface RulesTableActionsProps {
  onAddRule: () => void;
  onSave: () => void;
  onCancel: () => void;
  isDirty: boolean;
  isSaving: boolean;
  isAddDisabled?: boolean;
  isSaveDisabled?: boolean;
}

export function RulesTableActions({
  onAddRule,
  onSave,
  onCancel,
  isDirty,
  isSaving,
  isAddDisabled = false,
  isSaveDisabled = false,
}: RulesTableActionsProps) {
  return (
    <Flex direction="row" justify="between" align="center">
      <Button
        size="md"
        onClick={onAddRule}
        leadIcon={PlusOutlineIcon}
        emphasis="outlined"
        intent="secondary"
        disabled={isAddDisabled}
      >
        Add Rule
      </Button>

      <Flex direction="row" gap={3}>
        <Button size="md" onClick={onCancel} emphasis="transparent" intent="secondary" disabled={!isDirty || isSaving}>
          Cancel
        </Button>
        <Button
          size="md"
          onClick={onSave}
          intent="primary"
          disabled={!isDirty || isSaving || isSaveDisabled}
          loading={isSaving}
        >
          Save Changes
        </Button>
      </Flex>
    </Flex>
  );
}
